import type { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { type VariantProps, cva } from "class-variance-authority";

export interface IconProps {
	starticon?: IconProp;
	endicon?: IconProp;
	iconSize?: SizeProp | "default";
	iconColor?: IconVariantProps["color"];
	iconClassName?: string;
}

type IconVariantProps = VariantProps<typeof icon>;

export const icon = cva(null, {
	variants: {
		color: {
			dark: "text-dark",
			"primary-medium": "text-primary-medium",
			success: "text-success",
			warning: "text-warning",
			danger: "text-danger",
		},
	},
});
